import { Table } from '../../../modules/tables/types';
import { RowState } from '../../../stores/types';
import { CellCombinedProps } from '../../molecules/Cell/types';
import { FieldColumnItemCombinedProps } from '../../molecules/FieldColumnItem/types';
import { TableRowItemCombinedProps } from '../../molecules/TableRowItem/types';
import { CELL_CONFIG } from './constants';

export const getTableColumnProps = (table?: Table): FieldColumnItemCombinedProps[] => {
  if (!table) {
    return [];
  }

  const fieldNames = table.keyOrder.length ? table.keyOrder : Object.keys(table.schema);
  return fieldNames.map((fieldName) => {
    const { required, type } = table.schema[fieldName];
    return {
      text: { value: fieldName },
      indicator: { value: required ? '*' : '' },
      icon: CELL_CONFIG[type].icon,
      size: CELL_CONFIG[type].size,
      type: required ? 'Required' : 'Default',
      fieldType: type,
    };
  });
};

export const getTableRowItems = (
  page: number, perPage: number, tableState: RowState[], table?: Table,
): TableRowItemCombinedProps[] => {
  if (!tableState || !table) {
    return [];
  }

  const fieldNames = table.keyOrder.length ? table.keyOrder : Object.keys(table.schema);
  const tableRows: TableRowItemCombinedProps[] = tableState.map((_, entryIndex): TableRowItemCombinedProps => {
    const tableCells: CellCombinedProps[] = fieldNames.map((fieldName, columnIndex) => {
      const { type } = table.schema[fieldName];
      return {
        type: CELL_CONFIG[type].type,
        row: entryIndex,
        column: columnIndex,
      };
    });

    return {
      index: entryIndex,
      cellList: {
        cells: tableCells,
      },
      numberColumn: {
        text: {
          value: `${(page - 1) * perPage + entryIndex + 1}`,
        },
        index: entryIndex,
      },
    };
  });

  return tableRows;
};
